export default __webpack_public_path__ + "static/media/panel.15561a0d.jpeg";